import { render, staticRenderFns } from "./CommissionsPage.vue?vue&type=template&id=30a030f4&scoped=true&"
import script from "./CommissionsPage.vue?vue&type=script&lang=ts&"
export * from "./CommissionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionsPage.vue?vue&type=style&index=0&id=30a030f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a030f4",
  null
  
)

export default component.exports